import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { reduxForm, Field } from 'redux-form';

import AsyncSelect from '../../../shared/AsyncSelect/AsyncSelect';
import Link from '../../../shared/Link/Link';
import Button from '../../../shared/Button/Button';
import TextField from '../../../shared/FormFields/TextField';
import RadioContainer from '../../../shared/FormFields/RadioContainer';
import {
  getCartTotalWithExpenses,
  existsFreeShipping,
  hasFreeShipping,
} from '../../../../redux/modules/cart';
import {
  getShippingCost,
  saveShipping,
  createOrder,
  saveRicetta,
  getEnabledCities,
  geocodeAddress,
} from '../../../../redux/modules/checkout';
import { loadCities } from '../../../../redux/modules/cities';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

import './Ricetta.scss';

class Ricetta extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // locationRicetta: 'codice',
      locationRicetta: '',
      imagesRicetta: [],
      base64images: [],
      newAddress: false,
      pickupAtPharmacy: false,
      numeroRicetta: '',
      codiceFiscale: '',
      orarioMedico: '',
      addressRicetta: {
        address1: '',
        address2: '',
        city: '',
        province: '',
        zipcode: '',
        telefono: '',
      },
    };
  }

  componentDidMount() {
    if (!this.props.user.authenticated) {
      this.props.router.push('/accedi');
    }
  }

  changeCap = (event, newValue) => {
    this.setState({
      addressRicetta: {
        ...this.state.addressRicetta,
        zipcode: newValue,
      },
    });
  };

  saveRicettaData = () => {
    const { addressRicetta } = this.state;
    const user = this.props.user.data;
    const ricettaDataToSave = {};

    if (this.state.locationRicetta === 'immagine') {
      if (!this.state.newAddress) {
        ricettaDataToSave.name = user.shipping.name;
        ricettaDataToSave.address1 = user.shipping.address1;
        ricettaDataToSave.address2 = user.shipping.address2;
        ricettaDataToSave.zipcode = user.shipping.zipcode;
        ricettaDataToSave.city = user.shipping.city;
        ricettaDataToSave.province = user.shipping.province;
        ricettaDataToSave.images = this.state.base64images;
      } else {
        const ricettaCityArray = addressRicetta.city.split('|');
        ricettaDataToSave.name = addressRicetta.name;
        ricettaDataToSave.address1 = addressRicetta.address1;
        ricettaDataToSave.address2 = addressRicetta.address2;
        ricettaDataToSave.zipcode = addressRicetta.zipcode;
        ricettaDataToSave.city = ricettaCityArray[0];
        ricettaDataToSave.province = ricettaCityArray[1];
        ricettaDataToSave.telefono = addressRicetta.telefono;
        ricettaDataToSave.images = this.state.base64images;
      }
    } else if (this.state.locationRicetta === 'medico') {
      const ricettaCityArray = addressRicetta.city.split('|');
      ricettaDataToSave.name = addressRicetta.name;
      ricettaDataToSave.address1 = addressRicetta.address1;
      ricettaDataToSave.address2 = addressRicetta.address2;
      ricettaDataToSave.zipcode = addressRicetta.zipcode;
      ricettaDataToSave.city = ricettaCityArray[0];
      ricettaDataToSave.province = ricettaCityArray[1];
      ricettaDataToSave.telefono = addressRicetta.telefono;
      ricettaDataToSave.orarioMedico = this.state.orarioMedico;
    } else if (this.state.locationRicetta === 'codice') {
      ricettaDataToSave.numeroRicetta = this.state.numeroRicetta;
      ricettaDataToSave.codiceFiscale = this.state.codiceFiscale;
    } else if (this.state.locationRicetta === 'farmacia') {
      ricettaDataToSave.name = 'Farmacia';
    }

    this.props.saveRicetta({
      ricetta: ricettaDataToSave,
    });
    this.props.router.push('/spedizione');
  };

  ///////////////////////////////////////////////////////////////
  // GESTIONE COMUNI AUTOCOMPLETE

  getCities = (input, callback) => {
    if (!input) {
      if (!!callback) {
        callback(null, {
          options: [],
        });
      }
    }

    this.props.loadCities(input || null, 4).then(action => {
      if (!!callback) {
        callback(null, {
          options:
            !!action.payload && !!action.payload.length
              ? action.payload.map(city => {
                  return {
                    value: `${city.city}|${city.province}`,
                    label: `${city.city} (${city.province})`,
                  };
                })
              : [],
        });
      }
    });
  };

  renderSelectCities = ({
    input,
    id,
    name,
    label,
    type,
    placeholder,
    meta: { touched, error },
  }) => {
    return (
      <div className={`form-group ${touched && error && 'error'}`}>
        <AsyncSelect
          name={name}
          value={input.value}
          openOnClick={false}
          loadOptions={this.getCities}
          labelKey="label"
          valueKey="value"
          onChange={val => {
            if (val && val.value) {
              input.onChange(val);
            } else {
              input.onChange('');
            }
          }}
          onBlur={() => input.onBlur(input.value)}
          placeholder="Città"
          loadingPlaceholder="Caricamento..."
          clearValueText="Annulla"
          searchPromptText="Digita la città..."
        />
        {touched && error && <div className="error-text">{error}</div>}
      </div>
    );
  };

  handleChangeRicettaLocation = target => event => {
    this.setState({
      addressRicetta: {
        ...this.state.addressRicetta,
        [target]: target === 'city' ? event.value : event.target.value,
      },
    });
  };

  handleFiles = files => {
    const toBase64 = file =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    const base64images = [...this.state.base64images];
    const imagesRicetta = [...this.state.imagesRicetta];
    for (let i = 0; i < files.length; i++) {
      toBase64(files[i])
        .then(res => {
          base64images.push(res);
          imagesRicetta.push({
            base64: res,
            name: files[i].name,
          });
        })
        .catch(err => {
          console.error(err);
        });
    }
    setTimeout(
      () =>
        this.setState({
          base64images,
          imagesRicetta,
        }),
      1000
    );
  };

  handleDeleteImage = index => e => {
    e.stopPropagation();
    e.preventDefault();
    const base64images = Object.assign([], this.state.base64images);
    const imagesRicetta = Object.assign([], this.state.imagesRicetta);
    base64images.splice(index, 1);
    imagesRicetta.splice(index, 1);
    this.setState({
      base64images,
      imagesRicetta,
    });
  };

  render() {
    const { primaryColor, funzionalita } = this.props;
    const { allowFastShipping, allowSlotShipping } = funzionalita;

    const user = this.props.user.data;
    const disabled =
      this.state.locationRicetta === 'immagine'
        ? this.state.newAddress
          ? !this.state.addressRicetta.address1 ||
            this.state.addressRicetta.address1 === '' ||
            !this.state.addressRicetta.zipcode ||
            this.state.addressRicetta.zipcode === '' ||
            !this.state.addressRicetta.city ||
            this.state.addressRicetta.city === '' ||
            !this.state.addressRicetta.name ||
            this.state.addressRicetta.name === '' ||
            !this.state.addressRicetta.telefono ||
            this.state.addressRicetta.telefono === '' ||
            !this.state.base64images ||
            this.state.base64images.length === 0
          : this.state.base64images.length === 0
        : this.state.locationRicetta === 'medico'
        ? !this.state.addressRicetta.address1 ||
          this.state.addressRicetta.address1 === '' ||
          !this.state.addressRicetta.zipcode ||
          this.state.addressRicetta.zipcode === '' ||
          !this.state.addressRicetta.city ||
          this.state.addressRicetta.city === '' ||
          !this.state.addressRicetta.name ||
          this.state.addressRicetta.name === '' ||
          !this.state.addressRicetta.telefono ||
          this.state.addressRicetta.telefono === '' ||
          !this.state.orarioMedico ||
          this.state.orarioMedico === ''
        : this.state.locationRicetta === 'codice'
        ? !this.state.numeroRicetta ||
          this.state.numeroRicetta === '' ||
          !this.state.codiceFiscale ||
          this.state.codiceFiscale === ''
        : this.state.locationRicetta === 'farmacia'
        ? false
        : true;

    return (
      <div className="spedizione-ricetta">
        <form onSubmit={this.saveRicettaData}>
          <div className="row">
            <div className="col-sm-12">
              <h4 className="checkout-title">RICETTA</h4>

              {funzionalita.prescriptionUploadAllowCode && (
                <RadioContainer className="radio-first">
                  <input
                    type="radio"
                    id="codice"
                    name="locationRicetta"
                    checked={this.state.locationRicetta === 'codice'}
                    onClick={() => this.setState({ locationRicetta: 'codice' })}
                  />
                  <label htmlFor="codice">
                    <div className="radio-title">
                      Inserisci il numero della tua ricetta elettronica
                      {/* <div className="radio-subtitle">
                      Valido solo per gli utenti della regione lombardia.
                    </div> */}
                    </div>
                  </label>
                </RadioContainer>
              )}
              {this.state.locationRicetta === 'codice' && (
                <div className="new-shipping-address collapsing-element">
                  <div className="form-section">
                    <Field
                      name="ricetta.numeroRicetta"
                      component={TextField}
                      type="text"
                      label="Numero ricetta 1; Numero ricetta 2; ecc..."
                      onChange={ev =>
                        this.setState({ numeroRicetta: ev.target.value })
                      }
                    />
                    <Field
                      name="ricetta.codiceFiscale"
                      component={TextField}
                      type="text"
                      label="Codice fiscale"
                      onChange={ev =>
                        this.setState({ codiceFiscale: ev.target.value })
                      }
                    />
                  </div>
                </div>
              )}

              {funzionalita.prescriptionUploadAllowImage && (
                <RadioContainer className="radio">
                  <input
                    type="radio"
                    id="immagine"
                    name="locationRicetta"
                    checked={this.state.locationRicetta === 'immagine'}
                    onClick={() =>
                      this.setState({ locationRicetta: 'immagine' })
                    }
                  />
                  <label htmlFor="immagine">
                    <div className="radio-title">
                      Carica un'immagine della ricetta
                      <div className="radio-subtitle">
                        Pensiamo noi a ritirarla all'indirizzo che hai indicato.
                      </div>
                    </div>
                  </label>
                </RadioContainer>
              )}
              {this.state.locationRicetta === 'immagine' && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <address
                    className="shipping-address collapsing-element"
                    style={{
                      borderColor: primaryColor,
                      marginTop: 16,
                      opacity: this.state.newAddress ? 0.5 : 1,
                    }}
                  >
                    {user.shipping.name}
                    <br />
                    {user.shipping.address1}
                    <br />
                    {user.shipping.address2 && (
                      <span>
                        {user.shipping.address2}
                        <br />
                      </span>
                    )}
                    {user.shipping.zipcode} {user.shipping.city} (
                    {user.shipping.province})
                  </address>
                  <div
                    onClick={() =>
                      this.setState({ newAddress: !this.state.newAddress })
                    }
                    className="button-address"
                    style={{ border: `1px solid ${primaryColor}` }}
                  >
                    {this.state.newAddress ? 'ANNULLA' : 'MODIFICA'}
                  </div>
                </div>
              )}
              {this.state.locationRicetta === 'immagine' && (
                <div>
                  {this.state.newAddress && (
                    <div className="new-shipping-address collapsing-element">
                      <div className="form-section">
                        <Field
                          name="ricetta.name"
                          component={TextField}
                          type="text"
                          label="Destinatario"
                          onChange={this.handleChangeRicettaLocation('name')}
                        />
                        <Field
                          name="ricetta.address1"
                          component={TextField}
                          type="text"
                          label="Indirizzo"
                          onChange={this.handleChangeRicettaLocation(
                            'address1'
                          )}
                        />
                        <Field
                          name="ricetta.address2"
                          component={TextField}
                          type="text"
                          label="Note indirizzo"
                          onChange={this.handleChangeRicettaLocation(
                            'address2'
                          )}
                        />
                        <Field
                          name="ricetta.zipcode"
                          component={TextField}
                          id="ricetta.location.zipcode"
                          placeholder={user.shipping.zipcode}
                          type="text"
                          label="CAP"
                          normalize={normalizeZipcode}
                          onChange={this.changeCap}
                        />
                        <Field
                          name="ricetta.city"
                          id="shipping.city"
                          component={this.renderSelectCities}
                          label="Città"
                          onChange={this.handleChangeRicettaLocation('city')}
                        />
                        <Field
                          name="ricetta.telefono"
                          component={TextField}
                          type="text"
                          label="Telefono"
                          onChange={this.handleChangeRicettaLocation(
                            'telefono'
                          )}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
              {this.state.locationRicetta === 'immagine' && (
                <>
                  <input
                    accept=".jpg,.png,.pdf"
                    id="immagini-ricetta"
                    type="file"
                    multiple
                    style={{ display: 'none' }}
                    onChange={ev => this.handleFiles(ev.target.files)}
                  />
                  <label
                    className="box-image"
                    for="immagini-ricetta"
                    style={{ border: `2px dashed ${primaryColor}` }}
                  >
                    {this.state.imagesRicetta &&
                      this.state.imagesRicetta.length > 0 &&
                      this.state.imagesRicetta.map((image, i) => (
                        <div
                          className="row-image"
                          style={{
                            marginBottom:
                              this.state.imagesRicetta.length - 1 === i
                                ? 24
                                : 8,
                          }}
                        >
                          <div className="file-image">
                            {image.base64.includes('application/pdf') ? (
                              <div>PDF</div>
                            ) : (
                              <ImageDispatcher
                                src={image.base64}
                                style={{ height: 30, width: 30 }}
                              />
                            )}
                          </div>
                          <div className="file-name">{image.name}</div>
                          <div
                            className="file-delete"
                            onClick={this.handleDeleteImage(i)}
                          >
                            <ImageDispatcher
                              src="/static/images/icona-cestino.svg"
                              style={{ height: 30, width: 30, zIndex: 1000 }}
                            />
                          </div>
                        </div>
                      ))}
                    <div
                      className="upload-subdescription"
                      style={{ backgroundColor: primaryColor }}
                    >
                      CARICA DAL TUO COMPUTER
                      <div className="small-text">
                        (Massimo 10 immagini e/o pdf)
                      </div>
                    </div>
                  </label>
                </>
              )}

              {/* <RadioContainer className="radio with-more-bottom-pad">
                <input
                  type="radio"
                  id="farmacia"
                  name="locationRicetta"
                  checked={this.state.locationRicetta === 'farmacia'}
                  onClick={() => this.setState({locationRicetta: 'farmacia'})}
                />
                <label htmlFor="farmacia">
                  <div className="radio-title">
                    La ricetta è in Farmacia
                    <div className="radio-subtitle">
                      Seleziona questa opzione se la ricetta o il prememoria cartaceo
                      <br />
                      si trovano già in farmacia
                    </div>
                  </div>
                </label>
              </RadioContainer> */}

              {funzionalita.prescriptionUploadAllowMedic && (
                <RadioContainer className="radio">
                  <input
                    type="radio"
                    id="medico"
                    name="locationRicetta"
                    checked={this.state.locationRicetta === 'medico'}
                    onClick={() => this.setState({ locationRicetta: 'medico' })}
                  />
                  <label htmlFor="medico">
                    <div className="radio-title">
                      Richiedi il ritiro dal tuo medico
                      <div className="radio-subtitle">
                        Pensiamo noi a ritirare la ricetta dal tuo medico.
                      </div>
                    </div>
                  </label>
                </RadioContainer>
              )}
              {this.state.locationRicetta === 'medico' && (
                <div>
                  <div className="new-shipping-address collapsing-element">
                    <div className="form-section">
                      <Field
                        name="ricetta.name"
                        component={TextField}
                        type="text"
                        label="Destinatario"
                        onChange={this.handleChangeRicettaLocation('name')}
                      />
                      <Field
                        name="ricetta.address1"
                        component={TextField}
                        type="text"
                        label="Indirizzo"
                        onChange={this.handleChangeRicettaLocation('address1')}
                      />
                      <Field
                        name="ricetta.address2"
                        component={TextField}
                        type="text"
                        label="Note indirizzo"
                        onChange={this.handleChangeRicettaLocation('address2')}
                      />
                      <Field
                        name="ricetta.zipcode"
                        component={TextField}
                        id="ricetta.zipcode"
                        placeholder={user.shipping.zipcode}
                        type="text"
                        label="CAP"
                        normalize={normalizeZipcode}
                        onChange={this.changeCap}
                      />
                      <Field
                        name="ricetta.city"
                        id="shipping.city"
                        component={this.renderSelectCities}
                        label="Città"
                        onChange={this.handleChangeRicettaLocation('city')}
                      />
                      <Field
                        name="ricetta.telefono"
                        component={TextField}
                        type="text"
                        label="Telefono"
                        onChange={this.handleChangeRicettaLocation('telefono')}
                      />
                    </div>
                    <div style={{ display: 'flex' }}>
                      <div style={{ flex: 1 }}>Fascia oraria:</div>
                      <div style={{ flex: 1 }}>
                        <RadioContainer className="radio-hours">
                          <input
                            type="radio"
                            id="mattina"
                            name="orarioMedico"
                            checked={this.state.orarioMedico === 'mattina'}
                            onClick={() =>
                              this.setState({ orarioMedico: 'mattina' })
                            }
                          />
                          <label htmlFor="mattina">Mattina</label>
                        </RadioContainer>
                      </div>
                      <div style={{ flex: 1 }}>
                        <RadioContainer className="radio-hours">
                          <input
                            type="radio"
                            id="pomeriggio"
                            name="orarioMedico"
                            checked={this.state.orarioMedico === 'pomeriggio'}
                            onClick={() =>
                              this.setState({ orarioMedico: 'pomeriggio' })
                            }
                          />
                          <label htmlFor="pomeriggio">Pomeriggio</label>
                        </RadioContainer>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <hr className="total-line" />

          <div className="buttons">
            <Link to="/carrello" className="btn btn-thick btn-grey">
              Indietro
            </Link>
            <Button
              type="submit"
              className="btn btn-thick btn-primary"
              disabled={disabled}
            >
              Metodo di spedizione
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

const normalizeZipcode = value => (value || '').replace(/[^\d]/g, '');

Ricetta = reduxForm({
  form: 'checkoutRicetta',
  enableReinitialize: true,
})(Ricetta);

const mapStateToProps = state => {
  return {
    user: state.user,
    cart: state.cart,
    ricetta: state.checkout.ricetta,
    checkout: state.checkout,
    freeShippingThreshold:
      state.store.data.costiSpedizione.freeShippingThreshold,
    invoicePolicy: state.store.data.funzionalita.invoicePolicy,
    allowPickupAtPharmacy: state.store.data.funzionalita.allowPickupAtPharmacy,
    pickupIsPayedOnline: state.store.data.funzionalita.pickupIsPayedOnline,
    pickupAtPharmacyMessage:
      state.store.data.funzionalita.pickupAtPharmacyMessage,
    datiFarmacia: state.store.data.datiFarmacia,
    funzionalita: state.store.data.funzionalita,
    cartTotalWithExpenses: getCartTotalWithExpenses(state),
    existsFreeShipping: existsFreeShipping(state),
    hasFreeShipping: hasFreeShipping(state),
    advancedGa: state.store.data.features.advancedGa,
    primaryColor: state.store.data.loghiTemplate.brandColor,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getShippingCost,
    saveShipping,
    createOrder,
    loadCities,
    saveRicetta,
    getEnabledCities,
    geocodeAddress,
  })(Ricetta)
);
